<template>
  <div>
    <div v-if="savingOverlay === true">Saving Profile...</div>
    <div v-if="loadingOverlay === true">{{loadingOverlayText}}</div>
    <div>
      <div :value="displayAlert" :color="alertType">{{alertMsg}}</div>

      <h4 class="subheading grey--text">Add Client</h4>

      <div class="card">
        <div style="padding: 25px;">
          <form ref="newClientForm">
            <fg-input
              label="Client Name"
              v-model="model.clientName"
              v-validate="modelValidations.clientName"
              name="client"
              type="text"
              :error="getError('client')"
              required
            ></fg-input>
            <fg-input
              label="Website"
              v-model="model.website"
              v-validate="modelValidations.website"
              name="website"
              type="text"
              :error="getError('website')"
              required
            ></fg-input>
            <fg-input
              label="Client Instagram Profile"
              id="instagram"
              name="instagram"
              type="text"
              v-model="model.instagram"
            ></fg-input>
            <fg-input label="Addess " v-model="model.address1"></fg-input>
            <fg-input label="Addess 2" v-model="model.address2"></fg-input>
            <fg-input label="City" v-model="model.city" required></fg-input>
            <fg-input label="State" v-model="model.state"></fg-input>
            <fg-input label="Zip Code" v-model="model.zip"></fg-input>
            <fg-input label="Country" v-model="model.country"></fg-input>

            <p-button color="info" class="mr-4" type="submit" @click="onSubmit">SAVE PROFILE</p-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";

import axios from "axios";
import vueCountryRegionSelect from "vue-country-region-select";
import {
  clientProfileCreateApi,
  clientProfileReadApi,
  igCheckApi,
  clientProfileUpdateApi
} from "@/config/appSettings.js";
export default {
  name: "Profile",
  data: () => ({
    savingOverlay: false,
    loadingOverlay: false,
    loadingOverlayText: null,
    valid: true,
    validInstagram: true,
    website: null,
    alertMsg: null,
    alertType: null,
    displayAlert: false,
    igRules: [v => !!v || "Enter a valid Instagram profile"],
    textCheck: [
      v => {
        if (v !== null && typeof v !== "undefined") {
          return v.length > 2 || "Please enter more than 3 characters.";
        }
        return "Required";
      }
    ],

    model: {
      clientName: "",
      website: "",
      instagram: "",
      address1: null,
      address2: null,
      city: null,
      zip: null,
      country: null,
      state: null,
      region: ""
    },
    modelValidations: {
      clientName: {
        required: true,
        min: 3
      },
      website: {
        required: true,
        url: true
      }
    }
  }),

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        try {
          console.log("CHECKING IS VALID:", isValid);
          console.log("CHECKING REGISTER FORM: ", this.registerForm);
          this.$emit("on-submit", this.registerForm, isValid);
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err)
        }
      });
    },
   
    async onSubmit(e) {
      e.preventDefault();
      this.displayAlert = false;
      this.savingOverlay = true;
      try {
        let self = this;
        if ((await this.$validator.validateAll()) === true) {
          let formInfo = {};

          formInfo.instagram = this.model.instagram;
          formInfo.city = this.model.city;
          formInfo.state = this.model.state;
          formInfo.country = this.model.country;
          formInfo.usertoken = this.auth;
          formInfo.website = this.model.website;
          formInfo.businessName = this.model.clientName;
          formInfo.address1 = this.model.address1;
          formInfo.address2 = this.model.address2;
          formInfo.zipcode = this.model.zip;

          let profileUpdateApi = `${clientProfileCreateApi}`;
          let profileUpdate = await axios.post(profileUpdateApi, formInfo);

          console.log("SUBMIT SUCCESS", profileUpdate.data);

          if (profileUpdate.data.success === true) {
            this.$router.push("/client/list");
          } else {
            console.log("FAILED");
            self.savingOverlay = false;
            self.alertType = "error";
            self.alertMsg = "Please check all fields.";
            self.displayAlert = true;
            window.scrollTo(0, 0);
          }
        } else {
          self.savingOverlay = false;
          self.alertType = "error";
          self.alertMsg = "Please check all fields.";
          self.displayAlert = true;
          window.scrollTo(0, 0);
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR", err);
        self.savingOverlay = false;
        self.alertType = "error";
        self.alertMsg = "Please check all fields.";
        self.displayAlert = true;
        window.scrollTo(0, 0);
      }
    },
    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 100);
    },
    openLoadingModal() {
      this.loadingOverlay = true;
    }
  },
  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.email = firebase.auth().currentUser.email;
  },
  created() {
    let self = this;
    this.$validator.extend("instagramCheck", {
      getMessage(field, val) {
        return "Invalid instagram";
      },
      validate(value, field) {
        console.log("VALUE:", value);
        console.log("FIELD:", field);

        try {
          let profileName = value.replace(/[^a-zA-Z0-9_.]/g, "");

          if (typeof profileName === "undefined") {
            console.log("NO PROFILE NAME");
            return false;
          }
          return IGProfileData.getProfileDataDirect(profileName).then(
            igCheckResponse => {
              console.log(
                "CHECKING INSTAGRAM VEE VALIDATE",
                igCheckResponse.result
              );
              if (igCheckResponse.success === false) {
                //return false;
                console.log("NOT VALID INSTAGRAM :(");
                // resolve(false);
                return false;
              } else {
                console.log("VALID INSTAGRAM :)");
                //return igCheckResponse.result;
                return true;
                //resolve(true);
              }
            }
          );
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err);
          return false;
        }

        return end > start;
      }
    });
  }
};
</script>

<style scoped>
</style>